<div class="header-container">
  <h2>HERO Report</h2>

  <div class="row">
    <p>Submitted: {{ submittedDate | date: 'MM/dd/yyyy hh:mm a'}}</p>
    <p>Reporter: {{ reporter }}</p>
  </div>
</div>

<div #mapContainer class="map-container"></div>
